import tw from "twin.macro";

const OvalBadge = (props: {
  textToDisplay: string;
  primary?: boolean;
  disabled?: boolean;
}) => {
  return (
    <span
      css={[
        tw`text-xs font-semibold text-white px-2 py-0.5 rounded-full shrink-0`,
        props.primary && tw`bg-green-700`,
        !props.primary && tw`text-gray-400 bg-gray-200`,
      ]}
    >
      {/* {!active && (
        <span css={tw`w-1.5 h-1.5 rounded-full bg-white opacity-90`} />
      )} */}
      {props.textToDisplay}
    </span>
  );
};

export default OvalBadge;
